import '@unocss/reset/tailwind.css'
import '@arkit/ew-vue-components/dist/style.css'
;('./assets/main.css')
// import './assets/scss/main.scss'
import 'primevue/resources/primevue.min.css'
import 'primevue/resources/themes/aura-light-blue/theme.css' // theme can be changed to suit your preference
import 'virtual:uno.css'
import './web-component'

import { createApp, type App } from 'vue'

import { createRouterInstance } from './router';

import { createPinia, type PiniaPluginContext } from 'pinia'
import PrimeVue from 'primevue/config'
import {
    easyWebComponents,
    EwPanel,
    EwPanelContent,
    EwIcon,
    EwPopover,
    EwModal,
    EwButton
} from '@arkit/ew-vue-components'

import AppComponent from './App.vue'

import MultiSelect from 'primevue/multiselect'
import DialogModal from 'primevue/dialog'
//import SoundPlayer from "vue3-sound-player";
// import SmallSoundPlayer from "vue3-sound-player/src/components/smallSoundPlayer.vue";
import BigSoundPlayer from './components/vue3-sound-player/src/components/SoundPlayer.vue'
import InteractiveImage from 'primevue/image'
import PaginatorComponent from 'primevue/paginator'
import PostGallery from 'primevue/galleria'
import Tooltip from 'primevue/tooltip'
import QuizStepper from 'primevue/stepper'
import StepperPanel from 'primevue/stepperpanel'
import QuizCheck from 'primevue/checkbox'
import QuizRadioButton from 'primevue/radiobutton'
import MessageToast from 'primevue/toast'
import ToastService from 'primevue/toastservice'
import Menu from 'primevue/menu'
import SpeedDial from 'primevue/speeddial'
import ViewMore from 'primevue/inplace'
import Menubar from 'primevue/menubar'
import Swal from 'sweetalert2'
import ConfirmationService from 'primevue/confirmationservice'
import Card from 'primevue/card'
import MeterGroup from 'primevue/metergroup'
//@ts-ignore
import Howl from 'howler'
import AccordionPrimeVue from 'primevue/accordion'
import AccordionTab from 'primevue/accordiontab'
import TieredMenu from 'primevue/tieredmenu'
import Editor from 'primevue/editor'
import Rating from 'primevue/rating'
import ProgressSpinner from 'primevue/ProgressSpinner'
import Ripple from 'primevue/ripple'
import Sidebar from 'primevue/sidebar'
import DropdownStatus from 'primevue/dropdown'
import Inplace from 'primevue/inplace'
import Calendar from 'primevue/calendar'
import type { AppConfigDefinition } from './types';
import { DefaultConfig } from './config';

export function createReaderInstance(args:{selector: string, customConfig?: AppConfigDefinition}) {
    const app = createApp(AppComponent)
	const {selector, customConfig} = args
	const config = {...DefaultConfig, ...customConfig} 

    app.component('EwPanel', EwPanel)
    app.component('EwPanelContent', EwPanelContent)
    app.component('EwModal', EwModal)
    app.component('EwIcon', EwIcon)
    app.component('EwPopover', EwPopover)
    app.component('EwButton', EwButton)
    app.component('MultiSelect', MultiSelect)
    app.component('AccordionPrimeVue', AccordionPrimeVue)
    app.component('AccordionTab', AccordionTab)
    // app.component('SmallSoundPlayer', SmallSoundPlayer)
    app.component('BigSoundPlayer', BigSoundPlayer)
    app.component('DialogModal', DialogModal)
    app.component('InteractiveImage', InteractiveImage)
    app.component('PaginatorComponent', PaginatorComponent)
    app.component('PostGallery', PostGallery)
    app.component('QuizStepper', QuizStepper)
    app.component('StepperPanel', StepperPanel)
    app.component('QuizCheck', QuizCheck)
    app.component('QuizRadioButton', QuizRadioButton)
    app.component('Menu', Menu)
    app.component('SpeedDial', SpeedDial)
    app.component('ViewMore', ViewMore)
    app.component('Menubar', Menubar)
    app.component('MeterGroup', MeterGroup)
    app.component('Card', Card)
    app.component('Swal ', Swal)
    app.component('MessageToast', MessageToast)
    app.component('Howl', Howl)
    app.component('TieredMenu', TieredMenu)
    app.component('EditorComp', Editor)
    app.component('Rating', Rating)
    app.component('Sidebar', Sidebar)
    app.component('DropdownStatus', DropdownStatus)
    app.component('ProgressSpinner', ProgressSpinner)
    app.component('Inplace', Inplace)
    app.component('Calendar', Calendar)

    app.directive('ripple', Ripple)
    app.directive('tooltip', Tooltip)

    app.use(easyWebComponents)

    app.use(PrimeVue, { ripple: true })
    app.use(ToastService)
    const router = createRouterInstance(config.forceDetailsId);

    app.use(router)
    app.use(ConfirmationService)


	// * Start provides for global config
	app.provide("customConfig", config);

	const pinia = createPinia();
    app.use(pinia)

	// * Finally mount the app
	// console.log('Mounting app to ', selector)
	app.mount(selector)
	
    return app
}

// * Aiugment the window object
declare global {
	interface Window {
		createReaderInstance: (args:{selector: string, customConfig?: AppConfigDefinition}) => App<Element>
	}
}

window.createReaderInstance = createReaderInstance